const _excluded = ["children", "style", "timeout", "direction"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import { jsx as ___EmotionJSX } from "@emotion/react";
class Slide extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleEnter", node => {
      if (this.props.onEnter) this.props.onEnter(node);
    });
    _defineProperty(this, "handleExit", node => {
      if (this.props.onExit) this.props.onExit(node);
    });
    _defineProperty(this, "styles", {
      default: {
        transform: `translateY(${(() => {
          if (this.props.direction === 'down') return `-100%`;
          if (this.props.direction === 'up') return `100%`;
          return 0;
        })()}) translateX(${(() => {
          if (this.props.direction === 'right') return `-100%`;
          if (this.props.direction === 'left') return `100%`;
          return 0;
        })()})`,
        transition: `transform 250ms cubic-bezier(0.4, 0, 0.2, 1)`
      },
      entering: {
        transform: `translateX(0) translateY(0)`
      },
      entered: {
        transform: `translateX(0) translateY(0)`
      },
      exiting: {
        transform: `translateY(${(() => {
          if (this.props.direction === 'down') return `-100%`;
          if (this.props.direction === 'up') return `100%`;
          return 0;
        })()}) translateX(${(() => {
          if (this.props.direction === 'right') return `-100%`;
          if (this.props.direction === 'left') return `100%`;
          return 0;
        })()})`
      },
      exited: {
        transform: `translateY(${(() => {
          if (this.props.direction === 'down') return `-100%`;
          if (this.props.direction === 'up') return `100%`;
          return 0;
        })()}) translateX(${(() => {
          if (this.props.direction === 'right') return `-100%`;
          if (this.props.direction === 'left') return `100%`;
          return 0;
        })()})`
      }
    });
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }
  render() {
    const _this$props = this.props,
      {
        children,
        style: styleProp,
        timeout,
        direction
      } = _this$props,
      other = _objectWithoutProperties(_this$props, _excluded);
    const style = _objectSpread(_objectSpread(_objectSpread({}, styleProp), this.styles.default), /*#__PURE__*/React.isValidElement(children) ? children.props.style : {});
    console.log({
      direction,
      styles: this.styles
    });
    return ___EmotionJSX(Transition, _extends({
      appear: true,
      onEnter: this.handleEnter,
      onExit: this.handleExit,
      timeout: timeout === 'auto' ? null : timeout
    }, other), (state, childProps) => /*#__PURE__*/React.cloneElement(children, _objectSpread({
      style: _objectSpread(_objectSpread({}, style), this.styles[state])
    }, childProps)));
  }
}
Slide.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  in: PropTypes.bool,
  onEnter: PropTypes.func,
  onExit: PropTypes.func,
  style: PropTypes.object,
  theme: PropTypes.object,
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
};
Slide.defaultProps = {
  timeout: 250,
  direction: 'down'
};
export default Slide;